// İçerik analitiği (MOD-12 / K-3) — content-performance ekranı tipleri.
//
// Entity türleri BE `AnalyticsEntityTypes` ile birebir (magic-string yok). Yeni
// bir tür eklendiğinde hem burası hem BE sabiti güncellenir.

export const ANALYTICS_ENTITY_TYPES = ['article', 'page', 'campaign', 'branch'] as const;

export type AnalyticsEntityType = (typeof ANALYTICS_ENTITY_TYPES)[number];

/** Bir içeriğin seçili tarih penceresindeki görüntüleme/tıklama toplamı. */
export interface ContentPerformanceItem {
  entityType: string;
  entityId: string;
  title: string;
  slug: string;
  views: number;
  clicks: number;
}

export interface ContentPerformanceQuery {
  /** yyyy-MM-dd (DateOnly). */
  from: string;
  /** yyyy-MM-dd (DateOnly). */
  to: string;
  entityType?: string;
  page?: number;
  pageSize?: number;
}

export interface ContentPerformancePage {
  items: ContentPerformanceItem[];
  total: number;
  page: number;
  pageSize: number;
}
